import "./plugins/prototype";

import Vue from "vue";
import axios from "@/plugins/axios";
import router from "./router";
import store from "./store";
import vuetify, { consoleTheme } from "./plugins/vuetify";
import "./plugins/vue-dayjs";
import "./plugins/vue-cookies";
import "./plugins/vue-echarts";
import "./plugins/vuetify-draggable-treeview";

import App from "./AppConsole.vue";

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify: vuetify(consoleTheme),
    render: (h) => h(App),
}).$mount("#app");
